import cn from 'classnames'
import React from 'react'

const CannedReplyDropdownMenuListItem = React.forwardRef((props, ref) => {
  const {
    id,
    name,
    isFocused,
    focusedItemIcon,
    type,
    total,
    onClick,
    onMouseMove,
  } = props
  return (
    <div
      className={cn('item', type, {
        focused: isFocused,
      })}
      onClick={onClick}
      onMouseMove={onMouseMove}
      ref={ref}
    >
      <div className={cn('content', { empty: id < 0 })}>
        {name}
        {total && (
          <span className="count">{Number(total).toLocaleString()}</span>
        )}
      </div>
      <div className={cn('Icon', `Icon-${focusedItemIcon}`, 'focusedIcon')} />
    </div>
  )
})

export default CannedReplyDropdownMenuListItem
